/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogEmailResult
 */
export interface LogEmailResult {
  /**
   *
   * @type {string}
   * @memberof LogEmailResult
   */
  carrierEmailId: string;
  /**
   *
   * @type {number}
   * @memberof LogEmailResult
   */
  messageCount: number;
  /**
   *
   * @type {number}
   * @memberof LogEmailResult
   */
  attachmentCount: number;
}

/**
 * Check if a given object implements the LogEmailResult interface.
 */
export function instanceOfLogEmailResult(
  value: object,
): value is LogEmailResult {
  if (!("carrierEmailId" in value) || value["carrierEmailId"] === undefined)
    return false;
  if (!("messageCount" in value) || value["messageCount"] === undefined)
    return false;
  if (!("attachmentCount" in value) || value["attachmentCount"] === undefined)
    return false;
  return true;
}

export function LogEmailResultFromJSON(json: any): LogEmailResult {
  return LogEmailResultFromJSONTyped(json, false);
}

export function LogEmailResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogEmailResult {
  if (json == null) {
    return json;
  }
  return {
    carrierEmailId: json["carrierEmailId"],
    messageCount: json["messageCount"],
    attachmentCount: json["attachmentCount"],
  };
}

export function LogEmailResultToJSON(json: any): LogEmailResult {
  return LogEmailResultToJSONTyped(json, false);
}

export function LogEmailResultToJSONTyped(
  value?: LogEmailResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierEmailId: value["carrierEmailId"],
    messageCount: value["messageCount"],
    attachmentCount: value["attachmentCount"],
  };
}
